module.exports = __webpack_public_path__ + "grass-instance-2.f4f4a9e1fa6bc5d4eb396ff00ee1f447.png";